import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { claimAdReward, getQuota } from '../../lib/api';

/** 하루 이용 횟수 상태 (정책은 shared quota.ts) */
export function useQuota() {
  const q = useQuery({
    queryKey: ['quota'],
    queryFn: getQuota,
    staleTime: 10_000,
    // 화면에 들어올 때마다 서버 값을 다시 본다. 캐시된 값으로 "아직 여유 있음"이라 판단하면
    // 주제만 고르고 통과한 뒤 카드를 다 뽑고 나서 막히게 된다 (응답이 작아 비용은 무시할 만하다).
    refetchOnMount: 'always',
    retry: false,
  });
  return { quota: q.data ?? null, isLoading: q.isLoading };
}

/** 차감이 일어난 뒤 남은 횟수를 다시 읽어오게 한다 */
export function useRefreshQuota() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['quota'] });
}

/** 광고 시청 보상 받기 */
export function useAdReward() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: claimAdReward,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['quota'] }),
  });
}
